export default __webpack_public_path__ + "static/media/img_7.a936307b.jpg";